import { createContext } from 'react';

const geographicalData = window._sharedData.entry_data.geographical;

const GeographicalContext = createContext(geographicalData);
export default GeographicalContext;
export { geographicalData };
